var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFocus = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 2.07692C1.5 1.7583 1.7583 1.5 2.07692 1.5L8.25 1.5C8.66421 1.5 9 1.83579 9 2.25C9 2.66421 8.66421 3 8.25 3L3 3L3 8.25C3 8.66421 2.66421 9 2.25 9C1.83579 9 1.5 8.66421 1.5 8.25L1.5 2.07692Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.07692 22.5C1.7583 22.5 1.5 22.2417 1.5 21.9231L1.5 15.75C1.5 15.3358 1.83579 15 2.25 15C2.66421 15 3 15.3358 3 15.75L3 21H8.25C8.66421 21 9 21.3358 9 21.75C9 22.1642 8.66421 22.5 8.25 22.5H2.07692Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 21.9231C22.5 22.2417 22.2417 22.5 21.923 22.5L15.75 22.5C15.3357 22.5 15 22.1643 15 21.75C15 21.3358 15.3357 21 15.75 21L21 21L21 15.75C21 15.3358 21.3357 15 21.75 15C22.1642 15 22.5 15.3358 22.5 15.75L22.5 21.9231Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9231 1.49996C22.2417 1.49996 22.5 1.75825 22.5 2.07688V8.24996C22.5 8.66417 22.1642 8.99996 21.75 8.99996C21.3358 8.99996 21 8.66417 21 8.24996V2.99996L15.75 2.99996C15.3358 2.99996 15 2.66417 15 2.24996C15 1.83574 15.3358 1.49996 15.75 1.49996L21.9231 1.49996Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFocus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/focus.2de5312a06c83a7a7942fae36bcf0ffb.svg";